import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { setupAxiosInterceptor } from "../api/api";
import Header from "../components/header";
import "../styles/admin.css";

const alphabet = "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЮЯ".split("");

const Admin = () => {
  const [words, setWords] = useState([]);
  const [search, setSearch] = useState("");
  const [newWord, setNewWord] = useState("");
  const [newDefinition, setNewDefinition] = useState("");
  const [newRegion, setNewRegion] = useState("");

  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState(""); // "success" | "error"

  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const [regions, setRegions] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState("0");

    const [showWords, setShowWords] = useState(true); // true = show word list

    useEffect(() => {
      localStorage.removeItem("regions");
      loadRegions();
    }, []);

    const loadRegions = async () => {
      try {
        const res = await api.get("/dictionary/getregions");
        setRegions(res.data || []);
      } catch {
        console.error("Грешка при зареждане на региони.");
      } 
    };
  /* ===============================
     SEARCH
     =============================== */
  const searchWords = async () => {
    if (!search) {
      setWords([]);
      setMessage("Въведете дума за търсене.");
      return;
    }
    try {
      const res = await api.get("/dictionary/search", {
        params: { term: search,
        region: selectedRegion }
      });
      setWords(res.data || []);
      setMessage(res.data?.length === 0 ? "Няма резултати" : "");
    } catch {
      setMessage("❌ Грешка при търсене");
      setMessageType("error"); 
    }
  };
   /* ===============================
     FILTER BY LETTER
     =============================== */
  const filterByLetter = async (letter) => {
    setSearch("");
    try {
      const res = await api.get(`/dictionary/searchbyletter/${letter}`, {
        params: { region: selectedRegion }
      });
      setWords(res.data || []);
      setMessage(res.data?.length === 0 ? "Няма резултати" : "");
    } catch {
      setMessage("❌ Грешка при търсене");
      setMessageType("error"); 
    }
  };
  /* ===============================
     CLEAR
     =============================== */
  const clearAll = () => {
    setSearch("");
    setSelectedRegion("0");
    setWords([]);
    setMessage("");
  };  
    /* ===============================
     SEARCH TEMP WORDS
     =============================== */
  const showTempWords = async () => {
    try {
      const res = await api.get(`/dictionary/gettempwords`, {
      });
      setWords(res.data || []);
      setMessage(res.data?.length === 0 ? "Няма резултати" : "");
    } catch {
      setMessage("❌ Грешка при търсене");
      setMessageType("error"); 
    }
  };
  /* ===============================
     ADD WORD
     =============================== */
  const addWord = async () => {
    if (!newWord) {
      setMessage("Въведете дума");
      setMessageType("error"); 
      return;
    }
    if (!newDefinition) {
      setMessage("Въведете определение");
      setMessageType("error"); 
      return;
    }
    if (selectedRegion === "0") {
      setMessage("Изберете регион");
      setMessageType("error"); 
      return;
    }
    try {
      await api.post("/dictionary/addtofile", {
        term: newWord,
        definition: newDefinition,
        regionID: selectedRegion
      });
      setNewWord("");
      setNewDefinition("");
      setNewRegion("");
      setWords([]);
      setMessage("Думата е добавена");
      setMessageType("success");

      setSelectedRegion("0");

      setTimeout(() => {
        setMessage("");
      }, 3000);
    } catch {
      setMessage("❌ Грешка при добавяне");
      setMessageType("error"); 
    }
  };

  const deleteWord = async (id) => {
    try {
      await api.delete(`/dictionary/delete?id=${id}`);
      setWords(words.filter(w => w.id !== id));
    } catch {
      setMessage("❌ Грешка при изтриване");
      setMessageType("error"); 
    }
  };

  const confirmWord = async (id) => {
  try {
    const token = localStorage.getItem("token");

    await api.post(`/dictionary/confirmnewword?id=${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    setMessage("Думата е добавена");
    setMessageType("success");
    
    setWords(words.filter(w => w.id !== id));
  } catch {
    setMessage("❌ Грешка при добавяне");
    setMessageType("error"); 
  }
};

const deleteTempWord = async (id) => {
  try {
    const token = localStorage.getItem("token");

    await api.delete(`/dictionary/deletetempword?id=${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    setMessage("Думата е премахната");
    setMessageType("success");
    
    setWords(words.filter(w => w.id !== id));
  } catch {
    setMessage("❌ Грешка при изтриване");
    setMessageType("error"); 
  }
};

  const logout = () => {
    localStorage.removeItem("token");
    delete api.defaults.headers.common["Authorization"];
    navigate("/");
  };

  return (
    <div className="page-background">
      <div className="admin-container">
        <Header />

        <p>
            <select
            style={{ maxWidth: "50%" }}
            value={selectedRegion}
            onChange={(e) => {
              const value = e.target.value;

              setSelectedRegion(value === "" ? "0" : Number(value));

              setWords([]);
              setMessage("");
              setSearch("");
            }}
          >
            <option value="0">-- Всички региони --</option>

            {regions.map(r => (
              <option key={r.id} value={r.id}>
                {r.name}
              </option>
            ))}
          </select>
        </p> 
        {/* Alphabet */}
        <div className="alphabet-bar">
          {alphabet.map(letter => (
            <button
              key={letter}
              onClick={() => filterByLetter(letter)}
              className="alphabet-btn"
            >
              {letter}
            </button>
          ))}
        </div>

        {/* Search */}
        <div className="search-bar">
          <input
            type="text"
            placeholder="Търсене на дума..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setMessage("");
            }}
          />
          <div className="search-buttons">
            <button onClick={searchWords}>Търсене</button>
            <button onClick={clearAll}>Изчистване</button>
            <button onClick={() => setShowWords(!showWords)}>{showWords ? "Думи за одобрение" : "Обратно"}</button>
          </div>
        </div>

        {message && <p className={`message ${messageType}`}>{message}</p>}

        {/* Words */}
        {showWords && (
        <div className="word-list-container">
          <ul className="word-list">
            {words.map(w => (
              <li key={w.id} className="word-card">
                <div className="word-content">
                  <strong><u>{w.term}</u></strong>
                  <p><i>Регион:</i> {w.region}</p>
                  <p><i>Определение:</i> {w.definition}</p>
                </div>
                {token && (
                  <button
                    className="delete-btn"
                    onClick={() => deleteWord(w.id)}
                  >
                    Изтриване
                  </button>
                )}
              </li>
            ))}
          </ul>        

        {/* Add Word */}
        <div className="add-word">
          <h3>Добави дума</h3>
          <input
            type="text"
            placeholder="Дума"
            value={newWord}
            onChange={(e) => setNewWord(e.target.value)}
          />
          <textarea
            rows={4}
            placeholder="Определение"
            value={newDefinition}
            onChange={(e) => setNewDefinition(e.target.value)}
          />
          <button onClick={addWord}>Запис</button>
          <button onClick={logout} className="logout-btn">
            Изход
          </button>
        </div>
        </div>
        )}
        {/* Show temp word */}
        {!showWords && (
          <div className="add-word">
            <h3>Думи за одобрение</h3>
            <button onClick={showTempWords}>Покажи</button>
            <ul className="word-list">
            {words.map(w => (
              <li key={w.id} className="word-card">
                
                <div className="word-content">
                  <strong><u>{w.term}</u></strong>
                  <p><i>Регион:</i> {w.region}</p>
                  <p><i>Определение:</i> {w.definition}</p>
                </div>

                {token && (
                  <div className="word-actions">
                    <button
                      className="confirm-btn"
                      onClick={() => confirmWord(w.id)}
                    >
                      Потвърждаване
                    </button>
                    <button
                      className="delete-btn"
                      onClick={() => deleteTempWord(w.id)}
                    >
                      Изтриване
                    </button>                    
                  </div>
                )}

              </li>
            ))}
          </ul>   
        </div>
        )}
      </div>
    </div>
  );
};

export default Admin;
